import { email, givenName, familyName, name, nickName } from './cognito-atributes'

// Creating array to search the values that match with cognito values to autofill attribute form
const samlAttrMap = [
  {
    cognitoAttr: email,
    samlAttr: [
      'Email',
      'email',
      'emailAddress',
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/email'
    ]
  },
  {
    cognitoAttr: givenName,
    samlAttr: [
      'FirstName',
      'givenName',
      'firstName',
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname',
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/firstname'
    ]
  },
  {
    cognitoAttr: familyName,
    samlAttr: [
      'LastName',
      'surname',
      'familyName',
      'lastName',
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname',
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/familyname',
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/lastname'
    ]
  },
  {
    cognitoAttr: name,
    samlAttr: [
      'name',
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'
    ]
  },
  {
    cognitoAttr: nickName,
    samlAttr: [
      'nickname',
      'Nickname',
      'http://schemas.microsoft.com/identity/claims/nickname'
    ]
  }
]

const samlAttrToCognitoAttr = (samlAttr) => {
  const cognitoAttr = samlAttrMap.find((samlAttrMapItem) => {
    return samlAttrMapItem.samlAttr.includes(samlAttr)
  })
  return cognitoAttr
}

export { samlAttrToCognitoAttr }
